export default __webpack_public_path__ + "static/media/clogo.157c6418.svg";